<template>
  <div class="lucky-wheel">
    <div class="wheel-main">
      <div
        v-if="showPointer"
        @click="play"
      >
        <slot name="pointer">
          <div
            class="wheel-pointer"
          ></div>
        </slot>
      </div>
      <div
        id="luckyWheel"
        class="wheel-bg"
      >
        <div class="prize-list">
          <div
            v-for="(item, i) in prizeList"
            :key="i"
            class="prize-item"
            :style="item.style"
            :class="{ 'highlight': i === activeIndex }"
          >
            <div
              :style="rotate?item.childStyle:null"
              @click="clickItem(item)"
            >
              <slot
                name="prize"
                :item="item"
                :index="i"
              >
                <div class="prize-pic">
                  <img :src="item.icon" />
                </div>
                <div class="prize-type">
                  {{ item.name }}
                </div>
              </slot>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { RangeLoop } from '@/utils/lottery'
import { props } from '@/utils/lottery-props'

const CIRCLE_ANGLE = 360

export default {
  name: 'RotePointer',
  props: {
    ...props,
  },
  data() {
    return {
      index: -1, // 奖品索引
      prizeList: null, // 奖品列表
      isRotating: false, // 是否正在旋转
      activeIndex: -1, // 当前高亮的奖品索引
      rangeLoopInstance: null, // 转盘实例
    }
  },
  created() {
    this.initPrizeList()
  },
  methods: {
    initPrizeList() {
      this.prizeList = this.formatPrizeList(this.prizes)
      this.activeIndex = this.prizeList.length
    },
    // 格式化奖品列表
    formatPrizeList(list) {
      const l = list.length
      const average = CIRCLE_ANGLE / l
      const half = average / 2

      list.forEach((item, i) => {
        const angle = (i * average + half)
        item.style = `-webkit-transform: rotate(${angle}deg); transform: rotate(${angle}deg);`
        if (this.rotate) {
          item.childStyle = `-webkit-transform: rotate(${-angle}deg); transform: rotate(${-angle}deg);`
        }
      })
      return list
    },
    play() {
      const { isRotating } = this
      if (isRotating) {
        // 正在旋转的回调
        this.$emit('rotating')
        return
      }
      if (this.animation) {
        if (!this.rangeLoopInstance) {
          this.rangeLoopInstance = new RangeLoop({
            range: [0, this.prizes.length], // 转动在1-9之间
            speed: this.speed, // 速度
            factor: this.factor, // 阻尼系数
            loop: this.loop, // pick执行时多转一圈
            watchValue: (value) => {
              // 运功开始时绑定number，驱动页面动画
              this.activeIndex = Math.floor(value)
            },
            endCallback: (val) => {
              this.activeIndex = val
              //  结束回调
              this.$emit('end', this.prizes[val])
              this.isRotating = false
              this.rangeLoopInstance.reset(false)
            },
          })
        }
        this.isRotating = true
        this.rangeLoopInstance.play()
      }
      this.$emit('start')
    },

    // 停止旋转
    pick(index) {
      if (this.animation) {
        this.rangeLoopInstance.pick(index)
      } else {
        this.activeIndex = index
      }
    },

    clickItem(item) {
      this.$emit('clickPrize', item)
    },
  },
}
</script>

<style scoped>
  .lucky-wheel {
    width: 100%;
    background-size: 100%;
    padding-top: 20px;
  }
  .wheel-main {
    margin: 0 auto;
    position: relative;
    width: 295px;
    height: 295px;
  }
  .wheel-bg {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    width: 100%;
    height: 100%;
    background: url('../../assets/img/draw_wheel.png') no-repeat center top;
    background-size: 100%;
    color: #fff;
  }
  .wheel-pointer {
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 2;
    width: 85px;
    height: 85px;
    background: url('../../assets/img/draw_btn.png') no-repeat center top;
    background-size: 100%;
    transform: translate3d(-50%, -50%, 0);
  }
  .wheel-bg div {
    text-align: center;
  }
  .prize-list {
    width: 100%;
    height: 100%;
    position: relative;
  }
  .prize-list .prize-item {
    position: absolute;
    width: 95px;
    height: 150px;
    top: 0;
    left: 50%;
    margin-left: -47.5px;
    transform-origin: 50% 100%;
  }
  .prize-list .prize-item.highlight {
    background-color: yellow; /* Add yellow background to highlighted prize */
  }
  .prize-pic img {
    width: 4.0625rem;
    height: 2.5rem;
    margin-top: 1.5625rem;
  }
</style>
